import { CondRequestKeysType } from '@op/components/FilterCommon/types';
import {
  getFilterCondStorage,
  updateFilterCondStorage,
} from '@op/components/FilterCommon/utils/storage';
import { getOpinionFilterCond } from '@op/services';
import { useEffect, useMemo, useRef, useState } from 'react';

export function useFilterCondConf({
  gameInfo,
  needRequest = true,
  requestList,
  needRender = false,
}: {
  gameInfo: any;
  requestList: { key: CondRequestKeysType; defaultValue: any }[];
  needRequest?: boolean;
  needRender?: boolean;
}) {
  function getDefaultValue() {
    const keys: string[] = [];
    const defaultValue = requestList.reduce((pre, cur) => {
      keys.push(cur.key);
      return {
        ...pre,
        [cur.key]: cur.defaultValue,
      };
    }, {} as any);

    return {
      defaultValue,
      keys,
    };
  }
  const [loading, setLoading] = useState(true);
  const { defaultValue, keys } = useMemo(() => getDefaultValue(), []);

  const filterCondValue = useRef(defaultValue);
  const [filterCondState, setFilterCondState] = useState(defaultValue);

  function changeValue(value: any) {
    if (needRender) {
      setFilterCondState(value);
    } else {
      filterCondValue.current = value;
    }
  }

  useEffect(() => {
    if (!gameInfo?.edition_unified_id) return;

    setLoading(true);
    if (!needRequest) {
      setLoading(false);
      return;
    }
    // 先查找缓存
    const filterCond = getFilterCondStorage(gameInfo);
    const result: { [key: string]: any } = {};
    const needRequestKeys: string[] = [];

    keys.forEach(key => {
      const value = filterCond?.[key];
      if (value) {
        result[key] = value;
      } else {
        needRequestKeys.push(key);
      }
    });

    if (needRequestKeys.length === 0) {
      changeValue(result);
      setLoading(false);
      return;
    }

    const realKeys = needRequestKeys.filter(key => key !== 'topic_trans');
    const hasTopic = realKeys.length < needRequestKeys.length;

    // 再请求接口
    getOpinionFilterCond({
      ...gameInfo,
      request_type: realKeys,
      un_request_type: hasTopic ? [] : ['topic_trans'],
    })
      .then((data: any) => {
        updateFilterCondStorage(gameInfo, data);
        changeValue({ ...data, ...result });
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [gameInfo]);

  return {
    ...(needRender ? filterCondState : filterCondValue.current),
    changeValue,
    loading,
  };
}
